// apps/web/src/lib/format.ts

export function formatTime(isoString: string): string {
  const d = new Date(isoString)
  return d.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' })
}
